export const PAYMENTS = {
    OVERVIEW_RECORDS: 250,
    AMOUNT_MIN_RANGE: 0,
    AMOUNT_MAX_RANGE: 100000
}

export const PAYMENT_TYPE = {
    international: 'international',
    domestic: 'domestic',
    internal: 'internal',
    domesticuk: 'domesticuk-payments'
}

export const PAYMENT_BENF_SORT_VALUE = [
    { value: "Most recently used beneficiaries" },
    { value: "Beneficiary name" }
]

export const ICON_STYLE = {
    width: 26,
    height: 26,
  }
  